import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kt-no-records-image',
  templateUrl: './no-records-image.component.html',
  styleUrls: ['./no-records-image.component.scss']
})
export class NoRecordsImageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
